"use client";

import useMediaQuery from "@mui/material/useMediaQuery";
import { useHydrated } from "src/hooks/use-hydrated";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import LayersIcon from "@mui/icons-material/Layers";
import CardGiftcardOutlinedIcon from "@mui/icons-material/CardGiftcardOutlined";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import { iconStyle, StyledNavLink, Wrapper } from "./styles";
import SalifyFallback from "src/lib/components/salify-fallback/default";
import React from "react";
import { Button, SwipeableDrawer } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Global } from "@emotion/react";
import useTheme from "@mui/material/styles/useTheme";
import Box from "@mui/material/Box";
import CategoryMobileMenu from "src/lib/components/category-section/bazaar/category-mobile-menu";

const Puller = styled("div")(({ theme }) => ({
  width: 68,
  height: 10,
  backgroundColor: theme.palette.info.contrastText,
  borderRadius: 900,
  position: "absolute",
  top: "-20px",
  left: "calc(50% - 34px)",
}));

const drawerBleeding = 56;

const MobileNavigationBar = (props) => {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const hydrated = useHydrated();
  const down900Mq = useMediaQuery((t) => t.breakpoints.down(900));
  const DOWN_900 = hydrated && down900Mq;

  if (DOWN_900) {
    return (
      <>
        <SwipeableDrawer
          anchor="bottom"
          open={open}
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
          swipeAreaWidth={drawerBleeding}
          disableSwipeToOpen={false}
          ModalProps={{
            keepMounted: true,
          }}
        >
          <Global
            styles={{
              ".MuiDrawer-root > .MuiDrawer-paperAnchorBottom ": {
                height: `calc(75% - ${drawerBleeding}px)`,
                overflow: "visible",
                borderTopLeftRadius: 24,
                borderTopRightRadius: 24,
              },
            }}
          />
          <Box className="flex flex-col h-screen items-stretch">
            <Puller />
            <SalifyFallback.Value
              path="output:categories.data"
              default={[]}
              render={(items) => {
                return <CategoryMobileMenu lineStyle="none" navList={items || []} />;
              }}
            />
          </Box>
        </SwipeableDrawer>
        <Wrapper>
          <StyledNavLink href={"/"} key={"home"} active={open ? false : undefined}>
            <HomeOutlinedIcon sx={iconStyle} fontSize="small" />
            <SalifyFallback.Label path="home" default="Trang chủ" />
          </StyledNavLink>
          <Button
            sx={{
              flex: "1 1 0",
              display: "flex",
              fontSize: "13px",
              alignItems: "center",
              flexDirection: "column",
              justifyContent: "center",
              color: open ? theme.palette.primary.main : "inherit",
            }}
            key={"category"}
            onClick={(e) => {
              e.preventDefault();
              setOpen((o) => !o);
            }}
          >
            <LayersIcon sx={iconStyle} fontSize="small" />
            <SalifyFallback.Label path="category" default="Danh mục" />
          </Button>
          <StyledNavLink href={"/collection"} key={"promotion"} active={open ? false : undefined}>
            <CardGiftcardOutlinedIcon sx={iconStyle} fontSize="small" />
            <SalifyFallback.Label path="promotion" default="Khuyến mãi" />
          </StyledNavLink>
          <StyledNavLink href={`tel:${props?.hotline}`} key={"support"} active={false}>
            <HeadsetMicIcon sx={iconStyle} fontSize="small" />
            <SalifyFallback.Label path="support" default="Hỗ trợ" />
          </StyledNavLink>
        </Wrapper>
      </>
    );
  }

  return null;
};

export default MobileNavigationBar;
